import * as React from "react";

import { ITerminology } from "src/library/utils/string-manipulations/tokenize-string";
import OrderDayPickerModal from "src/core/orders/components/Modals/OrderDayPickerModal";
import useDrop from "src/core/drops/hooks/useDrop";
import { useOrder } from "src/core/orders/hooks";
import { IOrder } from "src/core/orders/api/orders.api";

interface DuplicateOrderModalProps {
    terminology: ITerminology,
    show: boolean;
    order: IOrder;
    closeModal: () => void;
}

/**
 * Component for a modal to duplicate an order for another delivery date
 *
 * @returns
 */
export const DuplicateOrderModal: React.ReactFCWithChildren<DuplicateOrderModalProps> = ({
  show, closeModal, order
}) => {
  const [ { drop } ] = useDrop();

  const [ , { duplicateOrder } ] = useOrder(
    order.id,
    order,
    false
  );

  if (!drop) {
    return null;
  }

  return (
    <OrderDayPickerModal
      drop={drop}
      show={show}
      handleDismiss={closeModal}
      orderVariantId={order.orderVariantId}
      modalTitle="Duplicate Order"
      onConfirm={(date, editBeforePlacing, customerReference) => {
        duplicateOrder(date, editBeforePlacing, customerReference),
        closeModal();
      }}
    />
  );
};
